<template>
  <div>
    <v-app-bar
      id="home-app-bar"
      app
      elevation="1"
      elevate-on-scroll
      class="hidden-overflow"
      height="80"
      extension-height="80"
    >
      <router-link to="/">
        <base-img
          :src="require('@/assets/logo_ets23.png')"
          contain
          max-width="130"
          width="100%"
        />
      </router-link>
      <span class="font-weight-bold ml-2 mr-2 my-2"></span>
      <a
      href="https://www.infineon.com/"
      target="_blank"
      >
      <base-img
        :src="require('@/assets/platinum-1.jpg')"
        contain
        max-width="110"
        width="100%"
      />
      </a>
      <!---
      <base-img
        :src="require(`@/assets/zero-logo-${$vuetify.theme.isDark ? 'dark' : 'light'}.svg`)"
                class="mr-3 hidden-xs-only"
        contain
        max-width="96"
        width="100%"
      />
--->
      <v-spacer />

      <div>
        <v-tabs
          class="hidden-md-and-down"
          optional
          background-color="transparent"
        >
          <v-tab
            v-for="item in items"
            :key="item.title"
            :to="item.to"
            :exact="item.title === 'Home'"
            :ripple="false"
            class="font-weight-bold"
            text
          >
            {{ item.title }}
          </v-tab>
        </v-tabs>
      </div>
      <!---
      <v-btn
        class="font-weight-bold ml-6"
        color="#11c684"
        dark
        depressed
        href="https://store.vuetifyjs.com/products/zero-theme-pro/?ref=vtyd-app-bar"
        rel="noopener"
        target="_blank"
        x-large
      >
        Upgrade to PRO
      </v-btn>
--->

      <v-app-bar-nav-icon
        class="hidden-lg-and-up"
        @click.stop="drawer = !drawer"
      />

      <template #extension>
        <v-container
          fluid
          v-show="!visibleWidth"
        >
        <!---           v-if="!isMobileDevice()" --->
          <v-slide-group
          show-arrows
          >
            <template v-for="(sponsor, i) in sponsors">
              <v-slide-item
                :key="i"
                class="align-self-center"
              >
                <a
                  :href="sponsor.to"
                  target="_blank"
                >
                  <base-img
                    v-bind="sponsor"
                    color="grey"
                    contain
                    height="50"
                    width="128"
                  />
                </a>
              </v-slide-item>

              <v-responsive
                v-if="i < 16"
                :key="`divider-${i}`"
                class="text-center"
                height="56"
                width="48"
              >
                <v-divider vertical />
              </v-responsive>
            </template>
          </v-slide-group>
        </v-container>
        <v-container
          fluid
          v-show="visibleWidth"
        >
          <v-slide-group
          id="mover"
          >
            <template v-for="(sponsor, i) in sponsorsDuplicated">
              <v-slide-item
                :key="i"
                class="align-self-center"
                style="display: inline-block;"
              >
                <a
                  :href="sponsor.to"
                  target="_blank"
                >
                  <base-img
                    v-bind="sponsor"
                    color="grey"
                    contain
                    height="40"
                    width="128"
                  />
                </a>

              </v-slide-item>
              <v-responsive
                v-if="i < 54"
                :key="`divider-${i}`"
                class="text-center"
                height="56"
                width="48"
              >
                <v-divider vertical />
              </v-responsive>
            </template>
          </v-slide-group>

        </v-container>
      </template>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      height="auto"
      fixed
      bottom
      temporary
    >
      <v-list
        v-for="item in items"
        :key="item.title"
        nav
        shaped
      >
        <div v-if="item.items != 0">
          <v-list-group>
            <template #activator>
              <v-list-item-content>
                <v-list-item-title
                :id="item.id"
                v-text="item.title"
                />
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="child in item.items"
              :key="child.title"
              :to="child.to"
              :id="child.id"
              :exact="item.title === 'Home'"
              @click="goTo(child.click)"
            >
              <v-list-group
              sub-group
              no-action
              v-if="child.items != 0"
              >
                <template #activator>
                  <v-list-item-content>
                    <v-list-item-title
                    :id="child.id"
                    v-text="child.title"
                    />
                  </v-list-item-content>
                </template>
                <v-list-item
                v-for="schild in child.items"
                :key="schild.title"
                :to="schild.to"
                :id="schild.id"
                :exact="child.title === 'Home'"
              >
              <v-list-item-title
              :id="schild.id"
              >
              {{ schild.title }}</v-list-item-title>
              </v-list-item>
              </v-list-group>
              <v-list-item-title
              v-else
              :id="child.id"
              >
              {{ child.title }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </div>
        <div v-else>
          <v-list-item
            :key="item.title"
            :to="item.to"
            :id="item.id"
            :exact="item.title === 'Home'"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>

  </div>
</template>

<script>
  export default {
    name: 'HomeAppBar',

    data: () => ({
      drawer: false,
      ok: true,
      visibleWidth: false,
      item_tabs: [
        'Home',
        'Committees',
        'Fringe Workshops',
        'Program',
        'Submissions',
        'Sponsors, Supporters and Partners',
        'Venue',
      ],
      sponsors: [
        {
          src: require('@/assets/logo-1-light.png'),
          to: 'https://www.ieee.org',
        },
        {
          src: require('@/assets/logo-2-light.png'),
          to: 'https://ieee-ceda.org',
        },
        {
          src: require('@/assets/logo-3-light.png'),
          to: 'https://www.cnrs.fr/en',
        },
        {
          src: require('@/assets/logo-4-light.png'),
          to: 'https://www.computer.org',
        },
        {
          src: require('@/assets/logo-5-light.png'),
          to: 'https://www.ieee-tttc.org',
        },
        /*
        {
          src: require('@/assets/logo-3-light.png'),
          to: 'https://inl.cnrs.fr/en/',
        },
        */
        {
          src: require('@/assets/logo-6-light.png'),
          to: 'https://www.polito.it',
        },
        {
          src: require('@/assets/logo-7-light.png'),
          to: 'https://inl.cnrs.fr/en/',
        },
        {
          src: require('@/assets/logo-8-light.png'),
          to: 'https://www.ec-lyon.fr/en',
        },
        {
          src: require('@/assets/partner-1-light.png'),
          to: 'https://www.itc-asia.info.hiroshima-cu.ac.jp/2023/',
        },
        {
          src: require('@/assets/partner-2-light.png'),
          to: 'https://www-elec.inaoep.mx/~LATS2023/',
        },
        {
          src: require('@/assets/partner-3-light.png'),
          to: 'https://www.swtest.org/',
        },
        {
          src: require('@/assets/partner-4-light.png'),
          to: 'https://orion.polito.it/iolts/',
        },
        {
          src: require('@/assets/partner-5-light.jpg'),
          to: 'https://www.mdpi.com/journal/sensors',
        },
        {
          src: require('@/assets/partner-6-light.png'),
          to: 'https://pesw.fit.cvut.cz/2023/',
        },
        {
          src: require('@/assets/partner-7-light.png'),
          to: 'https://ddecs2023.taltech.ee/',
        },
        {
          src: require('@/assets/partner-8-light.png'),
          to: 'https://www.ufrgs.br/isvlsi2023/',
        },
        {
          src: require('@/assets/partner-9-light.png'),
          to: 'https://nordictestforum.org/',
        },
      ],
      sponsorsDuplicated: [
        {
          src: require('@/assets/logo-1-light.png'),
          to: 'https://www.ieee.org',
        },
        {
          src: require('@/assets/logo-2-light.png'),
          to: 'https://ieee-ceda.org',
        },
        {
          src: require('@/assets/logo-3-light.png'),
          to: 'https://www.cnrs.fr/en',
        },
        {
          src: require('@/assets/logo-4-light.png'),
          to: 'https://www.computer.org',
        },
        {
          src: require('@/assets/logo-5-light.png'),
          to: 'https://www.ieee-tttc.org',
        },
        {
          src: require('@/assets/platinum-1.jpg'),
          to: 'https://www.infineon.com/',
        },
        {
          src: require('@/assets/gold-1.png'),
          to: 'https://www.siemens.com/',
        },
        {
          src: require('@/assets/gold-2.jpg'),
          to: 'https://www.technoprobe.com/',
        },
        {
          src: require('@/assets/silver-1.jpg'),
          to: 'https://www.synopsys.com/',
        },
        {
          src: require('@/assets/bronze-1.png'),
          to: 'https://www.arm.com/',
        },
        {
          src: require('@/assets/bronze-6.jpg'),
          to: 'https://www.eda-industries.net/en/',
        },
        {
          src: require('@/assets/bronze-2.jpg'),
          to: 'https://www.elmos.com/',
        },
        {
          src: require('@/assets/bronze-5.png'),
          to: 'https://www.proteantecs.com/',
        },
        {
          src: require('@/assets/bronze-3.png'),
          to: 'http://roguevation.com/',
        },
        {
          src: require('@/assets/bronze-4.png'),
          to: 'https://www.teradyne.com/',
        },
        {
          src: require('@/assets/logo-6-light.png'),
          to: 'https://www.polito.it',
        },
        {
          src: require('@/assets/logo-7-light.png'),
          to: 'https://inl.cnrs.fr/en/',
        },
        {
          src: require('@/assets/logo-8-light.png'),
          to: 'https://www.ec-lyon.fr/en',
        },
        {
          src: require('@/assets/partner-1-light.png'),
          to: 'https://www.itc-asia.info.hiroshima-cu.ac.jp/2023/',
        },
        {
          src: require('@/assets/partner-2-light.png'),
          to: 'https://www-elec.inaoep.mx/~LATS2023/',
        },
        {
          src: require('@/assets/partner-3-light.png'),
          to: 'https://www.swtest.org/',
        },
        {
          src: require('@/assets/partner-4-light.png'),
          to: 'https://orion.polito.it/iolts/',
        },
        {
          src: require('@/assets/partner-5-light.jpg'),
          to: 'https://www.mdpi.com/journal/sensors',
        },
        {
          src: require('@/assets/partner-6-light.png'),
          to: 'https://pesw.fit.cvut.cz/2023/',
        },
        {
          src: require('@/assets/partner-7-light.png'),
          to: 'https://ddecs2023.taltech.ee/',
        },
        {
          src: require('@/assets/partner-8-light.png'),
          to: 'https://www.ufrgs.br/isvlsi2023/',
        },
        {
          src: require('@/assets/partner-9-light.png'),
          to: 'https://nordictestforum.org/',
        },
        {
          src: require('@/assets/logo-1-light.png'),
          to: 'https://www.ieee.org',
        },
        {
          src: require('@/assets/logo-2-light.png'),
          to: 'https://ieee-ceda.org',
        },
        {
          src: require('@/assets/logo-3-light.png'),
          to: 'https://www.cnrs.fr/en',
        },
        {
          src: require('@/assets/logo-4-light.png'),
          to: 'https://www.computer.org',
        },
        {
          src: require('@/assets/logo-5-light.png'),
          to: 'https://www.ieee-tttc.org',
        },
        {
          src: require('@/assets/platinum-1.jpg'),
          to: 'https://www.infineon.com/',
        },
        {
          src: require('@/assets/gold-1.png'),
          to: 'https://www.siemens.com/',
        },
        {
          src: require('@/assets/gold-2.jpg'),
          to: 'https://www.technoprobe.com/',
        },
        {
          src: require('@/assets/silver-1.jpg'),
          to: 'https://www.synopsys.com/',
        },
        {
          src: require('@/assets/bronze-1.png'),
          to: 'https://www.arm.com/',
        },
        {
          src: require('@/assets/bronze-6.jpg'),
          to: 'https://www.eda-industries.net/en/',
        },
        {
          src: require('@/assets/bronze-2.jpg'),
          to: 'https://www.elmos.com/',
        },
        {
          src: require('@/assets/bronze-5.png'),
          to: 'https://www.proteantecs.com/',
        },
        {
          src: require('@/assets/bronze-3.png'),
          to: 'http://roguevation.com/',
        },
        {
          src: require('@/assets/bronze-4.png'),
          to: 'https://www.teradyne.com/',
        },
        {
          src: require('@/assets/logo-6-light.png'),
          to: 'https://www.polito.it',
        },
        {
          src: require('@/assets/logo-7-light.png'),
          to: 'https://inl.cnrs.fr/en/',
        },
        {
          src: require('@/assets/logo-8-light.png'),
          to: 'https://www.ec-lyon.fr/en',
        },
        {
          src: require('@/assets/partner-1-light.png'),
          to: 'https://www.itc-asia.info.hiroshima-cu.ac.jp/2023/',
        },
        {
          src: require('@/assets/partner-2-light.png'),
          to: 'https://www-elec.inaoep.mx/~LATS2023/',
        },
        {
          src: require('@/assets/partner-3-light.png'),
          to: 'https://www.swtest.org/',
        },
        {
          src: require('@/assets/partner-4-light.png'),
          to: 'https://orion.polito.it/iolts/',
        },
        {
          src: require('@/assets/partner-5-light.jpg'),
          to: 'https://www.mdpi.com/journal/sensors',
        },
        {
          src: require('@/assets/partner-6-light.png'),
          to: 'https://pesw.fit.cvut.cz/2023/',
        },
        {
          src: require('@/assets/partner-7-light.png'),
          to: 'https://ddecs2023.taltech.ee/',
        },
        {
          src: require('@/assets/partner-8-light.png'),
          to: 'https://www.ufrgs.br/isvlsi2023/',
        },
        {
          src: require('@/assets/partner-9-light.png'),
          to: 'https://nordictestforum.org/',
        },
      ],
      items: [
        /*
        {
          items: [],
          title: 'Home',
          to: '/',
          id: 'home-nav',
        },
        */
        {
          items: [],
          title: 'Gallery',
          to: 'gallery',
          id: 'gallery-nav',
        },
        {
          items: [
            {
              items: [],
              title: 'Program',
              to: 'program-calendar',
              id: 'program-calendar-nav',
            },
            {
              items: [],
              title: 'Accepted Scientific Papers',
              to: 'accepted-papers',
              id: 'accepted-papers-nav',
            },
            {
              items: [],
              title: 'Accepted Industrial Papers',
              to: 'accepted-industrial',
              id: 'accepted-industrial-nav',
            },
            {
              items: [],
              title: 'Posters',
              to: 'posters',
              id: 'posters-nav',
            },
          ],
          title: 'Program',
          to: 'program-conference',
          id: 'program-conference-nav',
        },
        {
          items: [],
          title: 'Registration',
          to: 'registration-fees',
          id: 'registration-nav',
        },
        {
          items: [],
          title: 'Social Event',
          to: 'social-event',
          id: 'social-event-nav',
        },
        {
          items: [
            {
              items: [],
              title: 'Program Chair',
              to: 'program-committee',
              id: 'program-chair-nav',
            },
            {
              items: [],
              title: 'Topic Chairs',
              to: 'topic-chairs',
              id: 'topic-chairs-nav',
            },
            {
              items: [],
              title: 'Program Committee Members',
              to: 'members',
              id: 'members-nav',
            },
            {
              items: [],
              title: 'Program Committee Companions',
              to: 'companions',
              id: 'companions-nav',
            },
            {
              items: [],
              title: 'Steering Committee',
              to: 'steering',
              id: 'steering-nav',
            },
            {
              items: [],
              title: 'Industrial Board',
              to: 'industrial',
              id: 'industrial-nav',
            },
            {
              items: [],
              title: 'Organizing Committee',
              to: 'organizing-committee',
              id: 'organizing-nav',
            },
          ],
          title: 'Committees',
          to: 'committees',
          id: 'committees-nav',
        },
        {
          items: [
            {
              items: [],
              title: 'Fringe Workshops',
              to: 'fringe-workshops',
              id: 'fringe-workshops-nav',
            },
            {
              items: [],
              title: 'AI-Treats',
              to: 'ai-treats',
              id: 'ai-treats-nav',
            },
            {
              items: [],
              title: 'eARTS',
              to: 'e-arts',
              id: 'e-arts-nav',
            },
            {
              items: [],
              title: 'IMTR',
              to: 'imtr',
              id: 'imtr-nav',
            },
          ],
          title: 'Workshops',
          to: 'workshops',
          id: 'fringe-workshops-parent-nav',
        },
        {
          items: [],
          title: 'TSS',
          to: 'test-spring-school',
          id: 'test-spring-school',
        },
        /*
        {
          items: [
            {
              items: [],
              title: 'Submit a Late Industrial',
              to: 'cfp',
              id: 'cfp-nav',
            },
            {
              items: [],
              title: 'Distinguished Service Award',
              to: 'distinguished-service-award',
              id: 'distinguished-service-award-nav',
            },
            {
              items: [],
              title: 'Key Dates',
              to: 'key-dates',
              id: 'key-dates-nav',
            },
            {
              items: [],
              title: 'Topics',
              to: 'topics',
              id: 'topics-nav',
            },
            {
              items: [],
              title: 'Submission Guidelines',
              to: 'submission-guidelines',
              id: 'submission-guidelines-nav',
            },
            {
              items: [
                {
                  items: [],
                  title: 'Scientific Papers',
                  to: 'camera-ready-scientific',
                  id: 'camera-ready-scientific-nav',
                },
                {
                  items: [],
                  title: 'Special Tracks Papers',
                  to: 'camera-ready-special',
                  id: 'camera-ready-special-nav',
                },
                {
                  items: [],
                  title: 'Industrial Papers',
                  to: 'camera-ready-industrial',
                  id: 'camera-ready-industrial-nav',
                },
              ],
              title: 'Camera-ready',
              to: 'camera-ready',
              id: 'camera-ready-nav',
            },
          ],
          title: 'Submissions',
          to: 'program',
          id: 'program-nav',
        },
        */
        {
          items: [
            {
              items: [],
              title: 'Student Activities at ETS23',
              to: 'student-activities-23',
              id: 'student-activities-23-nav',
            },
            {
              items: [],
              title: 'Best Student Presentation Award',
              to: 'bspa',
              id: 'bspa-nav',
            },
            {
              items: [],
              title: 'PhD Forum',
              to: 'student-phd-forum',
              id: 'student-phd-forum-nav',
            },
            {
              items: [],
              title: 'McCluskey Award',
              to: 'mccluskey',
              id: 'mccluskey-nav',
            },
            {
              items: [],
              title: 'Test Spring School',
              to: 'test-spring-school',
              id: 'tss-nav',
            },
            {
              items: [],
              title: 'Student Activities at ETS\'22',
              to: 'student-activities-22',
              id: 'student-activities-22-nav',
            },
          ],
          title: 'Students',
          to: 'student-activities',
          id: 'student-activities-nav',
        },
        {
          items: [
            {
              items: [],
              title: 'Supporters Opportunities',
              to: 'supporters',
              id: 'supporters-nav',
            },
            {
              items: [],
              title: 'Sponsors',
              to: 'sponsors',
              id: 'sponsors-nav',
            },
            {
              items: [],
              title: 'Supporters',
              to: 'supporters',
              id: 'supporters-nav',
            },
            {
              items: [
                {
                  title: 'Partner Conferences',
                  to: 'map',
                  id: 'map-nav',
                },
                {
                  title: 'Regional Contacts',
                  to: 'regional-contacts',
                  id: 'regional-contacts-nav',
                },
              ],
              title: 'Partners',
              to: 'map',
              id: 'partners-nav',
            },
          ],
          title: 'Sponsors',
          to: 'sponsors-supporters-partners',
          id: 'sponsors-supporters-partners-nav',
        },
        /*
        {
          items: [
            {
              items: [],
              title: 'Partner Conferences',
              to: 'map',
              id: 'map-nav',
            },
            {
              items: [],
              title: 'Regional Contacts',
              to: 'regional-contacts',
              id: 'regional-contacts-nav',
            },
          ],
          title: 'Regional',
          to: 'regional',
          id: 'regional-nav',
        },
        */
        {
          items: [
            {
              items: [],
              title: 'City of Venice',
              to: 'venice',
              id: 'venice-nav',
            },
            {
              items: [],
              title: 'Congress Center',
              to: 'congress-center',
              id: 'congress-center-nav',
            },
            {
              items: [],
              title: 'How To Reach',
              to: 'how-to',
              id: 'how-to-nav',
            },
            {
              items: [],
              title: 'Tips & Tricks',
              to: 'tips-tricks',
              id: 'tips-tricks-nav',
            },
            {
              items: [],
              title: 'Hotel Suggestions',
              to: 'hotel-rooms',
              id: 'hotel-rooms-nav',
            },
            {
              items: [],
              title: 'Visa',
              to: 'visa',
              id: 'visa-nav',
            },
          ],
          title: 'Venue',
          to: 'venue',
          id: 'venue-nav',
        },
        /*
        {
          items: [],
          title: 'Past Events',
          to: 'past-events',
          id: 'past-events-nav',
        },
        */
      ],
    }),
    mounted () {
      if (document.getElementById('mover')) {
        document.getElementById('mover').children[1].style.overflow = 'visible'
        //  document.getElementById('mover').children[1].style.width = '176'
        document.getElementById('mover').children[1].children[0].classList.add('mover')
      }
      window.addEventListener('resize', this.isMobileDevice)
      this.visibleWidth = this.isMobileDevice()
    },
    methods: {
      isMobileDevice () {
        //  return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        if (window.innerWidth < (176 * 14)) {
          this.visibleWidth = true
          return true
        } else {
          this.visibleWidth = false
          return false
        }
      },
      goTo (id) {
        if (id !== undefined) {
          //  document.getElementById(id + '-parent-nav').click()
          //  console.log(document.getElementById(id + '-parent-nav').children)
          //  document.getElementById(id + '-nav').click()
        }
      },
    },
  }
</script>
<style>
    .mover {
      height: 100%;
      -moz-animation: sponsors 40s linear 0.5s infinite;
      -moz-transform: translate3d(0,0,0);
      -webkit-animation: sponsors 40s linear 0.5s infinite;
      -webkit-transform: translate3d(0,0,0);
      animation: sponsors 40s linear 0.5s infinite;
      animation-fill-mode: forwards;
      transform: translate3d(0,0,0);
    }
    @-moz-keyframes sponsors{
      /*
      100%{
        -moz-transform:translateX(-280%)
      }
      */
      from {
        -moz-transform: translateX(0%);
      }
      to {
        -moz-transform: translateX(-51%);
      }
    }
    @-webkit-keyframes sponsors{
      /*
      100%{
        -webkit-transform:translateX(-280%)
      }
      */
      from {
        -webkit-transform: translateX(0%);
      }
      to {
        -webkit-transform: translateX(-51%);
      }
    }
    @keyframes sponsors{
      /*
      100%{
        -moz-transform:translateX(-100%);
        -webkit-transform:translateX(-280%);
        transform:translateX(-280%);
      }
      */
      from {
        transform: translateX(0%);
      }
      to {
          transform: translateX(-51%);
      }
    }
</style>
<style lang="sass">
  #home-app-bar
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none
      padding: 0 9px
      min-width: 10px
      font-size: 0.83rem !important
</style>
